import { Modal } from "@/common/components/modal"

interface Props {
  isOpen: boolean
  onClose: () => void
  cluster: any
}

export default function ViewClusterModal({ isOpen, onClose, cluster }: Props) {
  console.log("Cluster data in ViewClusterModal:", cluster) // Debugging log
  return (
    <Modal title="Cluster Details" isOpen={isOpen} close={onClose}>
      <div className="modal flex items-center justify-center rounded-3xl max-w-[800px] h-[20rem] md:w-[800px] bg-white p-6">
        <div className="grid grid-cols-3 gap-20">
          <div>
            <p className="text-xs text-gray-400">Cluster Name</p>
            <p className="text-sm font-medium text-gray-800">{cluster?.name}</p>
          </div>
          <div>
            <p className="text-xs text-gray-400">Cluster Code</p>
            <p className="text-sm font-medium text-gray-800">{cluster?.code}</p>
          </div>
          <div>
            <p className="text-xs text-gray-400">Cluster Location</p>
            <p className="text-sm font-medium text-gray-800">{cluster?.location}</p>
          </div>
          <div>
            <p className="text-xs text-gray-400">Date Added</p>
            <p className="text-sm font-medium text-gray-800">
              {new Date(cluster?.date_added || "").toLocaleDateString()}
            </p>
          </div>
          <div>
            <p className="text-xs text-gray-400">Description</p>
            <p className="text-sm font-medium text-gray-800">{cluster?.description}</p>
          </div>
          <div>
            <p className="text-xs text-gray-400">Last Update</p>
            <p className="text-sm font-medium text-gray-800">
              {new Date(cluster?.last_updated || "").toLocaleDateString()}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  )
}
